module.exports = __webpack_public_path__ + "static/media/Amber.73045dc5.jpg";